import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFound } from './404.component';

const rutas: Routes = [
  {
    path: '',
    component: NotFound,
  },
];

@NgModule({
  imports: [RouterModule.forChild(rutas)],
  exports: [RouterModule],
})
export class NotFoundRoutingModule {}
